// extracted by mini-css-extract-plugin
export default {"cls1":"sLPd6is3DI8WbTjhwJ8X","cls2":"tNPB7g8F_wNWwJlg8d7m sLPd6is3DI8WbTjhwJ8X","isPhone":"jKf8y56UGkD2gtcfVhpA"};